<template>
	<c-dialog ref="dialog" :title="false" width="auto" :button="false" @close="close">
		<video v-if="video" class="video" :src="src" loop autoplay controls></video>
		<img v-else ref="img" class="preview" :src="compSrc">
	</c-dialog>
</template>

<script>
	export default {
		name: 'preview',
		
		data() {
			return {
				type: '',
				src: ''
			}
		},
		
		computed: {
			video() {
				if (this.type == 'video') return true;
				var arr = this.src.split('.');
				return ['mp4', 'webm'].includes(arr[arr.length - 1]);
			},
			
			compSrc() {
				if (this.src.includes('x-oss-process')) {
					return this.src.substring(0, this.src.indexOf('?x-oss-process'));
				}
				
				return this.src;
			}
		},
		
		mounted() {
			if (!this.src) return;
			
			if (this.video) {
				this.$refs.dialog.open();
			} else {
				this.$loading();
				this.$refs.img.onload = () => {
					this.$loadOver();
					this.$refs.dialog.open();
				};
				this.$refs.img.onerror = () => {
					this.$loadOver();
					this.$message({
						text: '图片加载失败'
					})
				};
			}
		},
		
		methods: {
			close() {
				setTimeout(() => {
					this.$el.remove();
				}, 260);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .c-dialog {
		background: none;
		
		&-close {
			border-radius: 100%;
			color: #fff;
			background: rgba(0,0,0,.6);
			
			&:hover {
				color: #fff;
			}
		}
	}
	
	.preview {
		max-width: 60vw;
		max-height: 60vh;
	}
	
	.video {
		width: 80vw;
		height: 60vh;
		background: #000;
	}
</style>
